module.exports = __webpack_public_path__ + "img/insights@2x.4704c78a.png";